export { default } from "./myResultCard";
